import { apiPostAsync, apiTimeoutGet } from '../common/service-utils'
import * as constants from '../common/constants'
import * as JspUtil from '../common/JspUtil'
import * as loginactions from '../loginpages/actionCreators'
import { CONNECTION_TEST_STATE } from '../loginpages/actionTypes'
import * as registrationActions from '../registration/actionCreators'
import {
    ALL_SSO_APPS_RECEIVED, SSO_APPS_CORE_APPS,
    SSO_APPS_LOGIN_APPS, APP_UI_MSGS,
} from './actionTypes';

export * from './actionTypes';

let appGlobal = { appKey: "GLOBAL", description: JspUtil.getLabelFromJspVariables('globalid'), virtual: false };
let appAny = { appKey: "ANY", description: JspUtil.getLabelFromJspVariables('all_apps'), virtual: true };

export function getEnvironment() {
    return function (dispatch, getState) {
        apiPostAsync(constants.API_GET_ENVIRONMENT, null, {}).then(resp => {
            if (resp.data) {
                resp.data.showGroupHelp = false;
                if (resp.data.apps) {
                    try {
                        const apps = JSON.parse(resp.data.apps);
                        if (apps) processAppList(apps, dispatch);
                    } catch (e) { /* ignore parse errors */ }
                }
                if (resp.data.testConnection) {
                    try {
                        const config = getState().authenticateReducer.connectionTestState || {};
                        if (config && (!config.settings || !config.settings.done)) {
                            const settings = JSON.parse(resp.data.testConnection);
                            if (settings) {
                                dispatch(testConnection(settings));
                                settings.done = true;
                                dispatch({ type: CONNECTION_TEST_STATE, data: { settings } });
                            }
                        }
                    } catch (e) { /* ignore parse errors */ }
                }
                resp.data.verifyPhone = false;
                if (resp.data.validationRules) {
                    try {
                        const rules = JSON.parse(resp.data.validationRules);
                        if (rules && rules.verifyPhone == 'Y') {
                            resp.data.verifyPhone = true;
                        }
                    } catch (e) { /* ignore parse errors */ }
                }
                dispatch({ type: loginactions.SSO_ENV, data: resp.data });
            }
        }).catch(err => console.error('getEnvironment failed:', err));
    }
}

export function testConnection(testConnectionSettings) {
    return function (dispatch) {
        if (!checkUserConnection(testConnectionSettings)) {
            return;
        }
        const start = Date.now();
        let result = {};
        dispatch({ type: CONNECTION_TEST_STATE, data: { results: result } });
        let ts = 5000;
        if (testConnectionSettings.ts) {
            ts = testConnectionSettings.ts;
        }
        for (let url of testConnectionSettings.urls) {
            pingUrl(start, result, url, '/api/myIp', null, ts);
        }
        let appUrl = checkAppAndPermissions(testConnectionSettings);
        if (appUrl) {
            pingUrl(start, result, appUrl, null, null, ts);
        }
    }
}

export function testIconConnection(appUrl) {
    return function (dispatch, getState) {
        if (appUrl) {
            const connState = getState().authenticateReducer.connectionTestState || {};
            let result = connState.iconResults;
            if (result && result[appUrl]) {
                return;
            }
            const start = Date.now();
            let ts = 5000;
            const config = connState.settings;
            if (config && config.ts) {
                ts = config.ts;
            }
            dispatch({ type: CONNECTION_TEST_STATE, data: { iconResults: result } });
            pingUrl(start, result, appUrl, null, getState().authenticateReducer.authenticatedUser, ts);
        }
    }
}

export function getAppUiMessages(appKey, registrationPlaceHolders) {
    return function (dispatch) {
        const postData = { appKey, placeHolders: registrationPlaceHolders || constants.PAGE_PLACEHOLDERS };
        apiPostAsync(constants.API_APP_UI_MSGS, null, postData)
            .then(resp => dispatch({ type: APP_UI_MSGS, data: resp.data }))
            .catch(err => console.error('getAppUiMessages failed:', err));
    }
}

export function getAppBrandConfig(appKey) {
    return function (dispatch) {
        apiPostAsync(constants.API_APP_BRAND_CONFIG, null, { appKey })
            .then(resp => dispatch({ type: registrationActions.BRAND_CONFIG_RECEIVED, data: resp.data }))
            .catch(err => console.error('getAppBrandConfig failed:', err));
    }
}

function pingUrl(start, result, url, path, authData, ts) {
    let targetUrl = url;
    if (path) {
        targetUrl = url + path;
    }
    const initResult = {
        "url": url,
        "status": "pending",
        "pingStart": start
    };
    result[url] = initResult;
    let cb = resp => {
        if (resp.code == 0) {
            try {
                let testResult = {
                    "url": url,
                    "status": "success",
                    "pingStart": start,
                    "pingEnd": Date.now()
                };
                result[url] = testResult;
            } catch (e) {
            }
        }
        else {
            let testResult = {
                "url": url,
                "err": resp.error ? (resp.error.message ? resp.error.message : JspUtil.getLabelFromJspVariables('err_unknown')) : JspUtil.getLabelFromJspVariables('err_unknown'),
                "status": "failure",
                "pingStart": start,
                "pingEnd": Date.now()
            };
            result[url] = testResult;
        }
        if (authData && authData.user) {
            upload(authData, result[url]);
        }
    };
    cb.handlesOwnError = true;
    apiTimeoutGet(targetUrl, null, cb, ts);
}

function checkAppAndPermissions(settings) {
    if (settings.apps) {
        for (let a of settings.apps) {
            if (typeof jspLoginApp != 'undefined') {
                if (a.app === jspLoginApp) {
                    if (a.url) {
                        return a.url;
                    }
                }
            }
            if (typeof jspPermissions != 'undefined') {
                if (a.app === jspPermissions) {
                    if (a.url) {
                        return a.url;
                    }
                }
            }
        }
    }
    return null;
}

function checkUserConnection(settings) {
    if (settings && settings.urls) {
        const host = window.location.hostname;
        if (host != settings.host) {
            return false;
        }
        if (checkAppAndPermissions(settings)) {
            return true;
        }
        if (settings.noLauncher && settings.noLauncher === 'Y') {
            if (typeof jspLoginApp != 'undefined' && jspLoginApp == constants.APP_LAUNCHER) {
                return false;
            }
        }
        return true;
    }
    return false;
}

function upload(authData, testResult) {
    apiPostAsync(constants.API_LOG_USER_CONNECTION, null, {
        userId: authData.user,
        appKey: authData.app,
        permissions: 'MEMBERULP',
        appCompanyId: authData.appCompanyId,
        appCompanyName: authData.appCompanyName,
        authStart: '' + Date.now(),
        authEnd: '' + Date.now(),
        pingStart: testResult.pingStart + '',
        pingEnd: testResult.pingEnd + '',
        url: testResult.url,
        err: testResult.err,
        status: testResult.status,
    }).catch(err => console.error('upload connection log failed:', err));
}
function processAppList(appData, dispatch) {
    let uniqueApps = {};
    uniqueApps[appAny.appKey] = 1;
    uniqueApps[appGlobal.appKey] = 1;
    let apps = [];
    for (let k in appData) {
        let rec = appData[k];
        if (uniqueApps[rec.appKey]) continue;
        uniqueApps[rec.appKey] = rec;
        apps.push(rec);
    }

    // include ANY, GLOBAL, and non virtual apps
    let loginApps = [];

    [appAny, appGlobal].concat(apps).forEach(function (application) {
        if (application.appKey != 'ANY' && !application.hasApiUsers && application.virtual) return;
        loginApps.push(application);
    });

    // include non-virtual apps
    let coreApps = [];
    [appGlobal].concat(apps).forEach(function (application) {
        if (application.virtual && !application.hasApiUsers) return;
        coreApps.push(application);
    });

    dispatch({ type: ALL_SSO_APPS_RECEIVED, data: appData });
    dispatch({ type: SSO_APPS_CORE_APPS, data: coreApps });
    dispatch({ type: SSO_APPS_LOGIN_APPS, data: loginApps });
    let selectedApp = loginApps[0].appKey;
    if (typeof jspApp != 'undefined' && JspUtil.isValueAvailable(jspApp)) {
        selectedApp = jspApp;
    }
    else if (typeof jspLoginApp != 'undefined' && JspUtil.isValueAvailable(jspLoginApp)) {
        selectedApp = jspLoginApp;
    }
    dispatch({ type: loginactions.USER_INPUT_APP_KEY_CHANGE, data: selectedApp });
}
